import { Target } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const TargetTypesFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const targetTypeOptions: ComboboxFilterOption<string>[] = [
    { value: 'Insurance::Premium', label: 'Premium' },
    { value: 'Insurance::Enrollment', label: 'Enrollment' },
    { value: 'ICHRA::EnrollmentCoverage', label: 'Enrollment Coverage' },
  ]

  const filteredOptions = targetTypeOptions.filter(
    (option) =>
      (option.label || '').toLowerCase().includes(query.toLowerCase()) ||
      option.value.toLowerCase().includes(query.toLowerCase())
  )

  return (
    <ComboboxMultiSelectFilter
      {...props}
      options={[{ groupLabel: 'Target Types', options: filteredOptions }]}
      placeholder='Search target types to filter...'
      onValueChange={setQuery}
    >
      <FilterManagementDropdown
        {...props}
        options={targetTypeOptions}
        noSelectionText='Target Types'
        pluralIdentifier='target types'
      >
        <Target size={20} />
      </FilterManagementDropdown>
    </ComboboxMultiSelectFilter>
  )
}

export default TargetTypesFilter
